import React from "react";
import { Link } from "react-router-dom";
import sd from "../assets/SubhadipDas.png";

const Footer = () => {
  const handleToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <div>
      <div className="pb-3">
        <footer className="bg-purple-800 h-full px-10 rounded-3xl mx-5 flex flex-col">
          <div className="sm:flex sm:justify-around">
            <div className=" py-6">
              <div className="flex flex-wrap space-x-2">
                <div>
                  <img
                    className="h-14 w-14 sm:h-16 sm:w-16 rounded-full"
                    src={sd}
                    alt="Subhadip Das"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <div className="uppercase text-slate-200 text-lg font-bold font-serif mb-5 pt-3">
                  Subhadip Das
                </div>
                <div className="text-white font-semibold text-2xl sm:pl-10 py-2 flex space-x-3">
                  <div>
                    <a
                      href="https://wa.me/916295619720"
                      data-action="share/whatsapp/share"
                    >
                      <i className="fa-brands fa-whatsapp"></i>
                    </a>
                  </div>
                  <div>
                    <a href="https://www.instagram.com/__im_dip__?utm_source=qr&igsh=NjZpOGd4cXU5NW05">
                      <i className="fa-brands fa-instagram"></i>
                    </a>
                  </div>
                  <div>
                    <a href="https://www.facebook.com/profile.php?id=100011328076778&mibextid=kFxxJD">
                      <i className="fa-brands fa-facebook"></i>
                    </a>
                  </div>
                  <div className="sm:hidden">
                    <a href="sms:916295619720">
                      <i className="fa-solid fa-comment-sms"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div className="text-slate-200 font-semibold sm:pr-24 my-4">
                I am Subhadip Das, currently working at Think Hat Business
                Solutions. I have completed my Bachelor of Technology from Gargi
                Memorial Institute of Technology in Computer Science And
                Engineering. I have achieved 90% in Higher secondary and 89.9%
                in Secondary boards examination from Haldia Govt. Spons.
                Vivekananda Vidyabhawan and Vivekananda Mission Asram
                Sikshayatan respectively. I am a hard-working and curious
                person. I want to upgrade my skills, want to be familiar with
                industrial culture and want to learn more about various
                technologies. I can communicate fluently in different languages
                such as English, Hindi, and Bengali.
              </div>
            </div>
            <div className=" py-7">
              <div className="uppercase text-slate-200 text-lg font-bold font-serif sm:flex sm:justify-center mb-5">
                Portfolio
              </div>
              <div className="sm:flex sm:justify-between sm:space-x-36 text-slate-200 font-semibold">
                <div>
                  <ul className="">
                    <li className="cursor-pointer" onClick={handleToTop}>
                      <Link to="/">Home</Link>
                    </li>
                    <li className="cursor-pointer" onClick={handleToTop}>
                      <Link to="/references">References</Link>
                    </li>
                    <li className="cursor-pointer" onClick={handleToTop}>
                      <Link to="/feedback">Feedback</Link>
                    </li>
                  </ul>
                </div>
                <div>
                  <ul>
                    <li className="cursor-pointer" onClick={handleToTop}>
                      <Link to="/education">Education</Link>
                    </li>
                    <li className="cursor-pointer" onClick={handleToTop}>
                      <Link to="/experience">Experience</Link>
                    </li>
                    <li className="cursor-pointer" onClick={handleToTop}>
                      <Link to="/projects">Projects</Link>
                    </li>
                  </ul>
                </div>
                <div>
                  <ul>
                    <li className="cursor-pointer" onClick={handleToTop}>
                      <Link to="/certificates">Certificates</Link>
                    </li>
                    <li className="cursor-pointer" onClick={handleToTop}>
                      <Link to="/skills">Skills</Link>
                    </li>
                    <li className="cursor-pointer" onClick={handleToTop}>
                      <Link to="/resume">Resume</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div>
            <hr />
          </div>
          <div className="sm:flex sm:justify-center sm:space-x-5 my-5 text-slate-200">
            <div className="text-lg font-semibold" onClick={handleToTop}>
              <Link to="/">Portfolio Website</Link>
            </div>
            <div className="text-lg font-bold hidden sm:block">|</div>
            <div
              className="uppercase text-lg font-semibold"
              onClick={handleToTop}
            >
              <Link to="/">Subhadip Das</Link>
            </div>
            <div className="text-lg font-bold hidden sm:block">|</div>
            <div className="text-lg font-semibold" onClick={handleToTop}>
              <Link to="/">subhadipdas.innovexdev.com</Link>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default Footer;
